export * from './deactivation.interface';
